<template>
  <div>
    <div class="content main-side-menu">
      <ul class="list nav-menu">
        <li
          class="item item-icon-right"
          v-for="(items, index) in routers"
          :key="index"
        >
          <ul class="sub-list">
            <li v-for="x in items.data" :key="x.url">
              <div v-if="!x.params" class="title" @click="goPage(x.url)">
                <span>{{ x.name }}</span>
                <RightOutlined></RightOutlined>
              </div>
              <div class="w-params" v-if="x.params">
                <div class="title">{{ x.name }}</div>
                <div class="params">
                  <div class="i-input-wrapper">
                    <a-select
                      v-model:value="x.par"
                      :defaultValue="x.par"
                      style="width: 100%"
                    >
                      <a-select-option
                        v-for="x in x.parList"
                        :key="x.value"
                        :value="x.value"
                      >
                        {{ x.name }}
                      </a-select-option>
                    </a-select>
                  </div>
                  <a-button
                    :disabled="x.par === ''"
                    @click="goHref(x.url, x.par)"
                  >
                    Go
                  </a-button>
                </div>
              </div>
            </li>
          </ul>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
  import { RightOutlined } from '@ant-design/icons-vue'
  export default {
    name: 'SpoMenu',
    components: {
      RightOutlined,
    },
    props: {
      routers: {
        type: Array,
        required: true,
      },
    },
    data() {
      return {}
    },
    created() {},
    methods: {
      goHref(url, par) {
        let link = ''
        if (url) {
          link = `/${url}/${par.replace(/\+/g, '%2b')}`
        } else {
          link = `/${par.replace(/\+/g, '%2b')}`
        }
        this.$router.push(link)
      },
      goPage(url) {
        const aUrl = url.replace(/\./g, '/')
        let u = /^\//.test(aUrl) ? aUrl : '/' + aUrl

        // supermaket url "supermarket({regionCode:'SM'})" 这种形式的 url单独处理
        const handUrl = url.match(/(\w+)\(\{(\S*)\}\)/)
        if (handUrl && handUrl.length) {
          const region = handUrl[2].match(/'(\w+)'/)[1]
          u = '/' + handUrl[1] + '/' + region
        }
        this.$router.push(u)
      },
    },
  }
</script>
<style lang="less" scoped>
  @import '~@/styles/variables.less';
  @black8: #333;
  @black2: #0000001a;
  @black1: #00000033;

  ul,
  li {
    list-style: none;
    padding: 0;
    margin: 0;
  }

  .main-side-menu {
    background-color: @gray-f;
    li.item {
      background-color: transparent;
      color: @black8;
      padding: 0;
      border-bottom: 10px solid #efefef;
      .sub-list > li {
        cursor: pointer;
        padding: 10px;
        position: relative;
        border-bottom: 1px solid rgba(0, 0, 0, 0.1);
        .title {
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          font-weight: 600;
          color: #323c4a;
          display: flex;
          align-items: center;
          justify-content: space-between;
        }
        .i-input-wrapper {
          position: relative;
          flex: 1;
          padding-right: 5px;
          .icon {
            right: 0;
          }
        }
        .inp-txt,
        .i-input-wrapper input[type='text'] {
          border: 1px solid @black1;
          padding: 5px;
          border-radius: 5px;
          height: 39px;
          line-height: 39px;
          width: 100%;
          background-color: @gray-f;
          font-size: 13px;
        }

        .button {
          background-color: #f8f8f8;
          width: 50px;
          border: 1px solid @black1;
          min-height: 38px;
          line-height: 38px;
          margin: 0;
          height: 40px;
          font-size: 16px;
        }
        .params {
          position: relative;
          padding: 5px 0 0 0;
          display: flex;
        }
      }
    }
    li.item:nth-child(even) {
      background: #f8f8f8;
    }
    li.item:nth-child(odd) {
      background: #f8f8f8;
    }
    .item-icon-right .icon {
      font-size: 16px;
      right: 5px;
      transition: all 0.1s;
    }
    .item-icon-right .icon.open {
      transform: rotate(180deg);
    }
    .bar-header {
      background-color: hsla(210, 5%, 90%, 1);
      border-color: @black2;
      .title {
        color: #323c4a;
        font-size: 18px;
        top: -2px;
        height: 44px;
        line-height: 44px;
      }
      &.bar .title + .button:before {
        font-size: 28px;
      }
    }
  }
  @media screen and (max-width: 720px) {
    .main-side-menu {
      li.item {
        border-bottom: 10px solid #efefef;
        .sub-list > li {
          padding: 10px;

          .i-input-wrapper {
            padding-right: 5px;
          }
          .inp-txt,
          .i-input-wrapper input[type='text'] {
            padding: 5px;
            border-radius: 5px;
            height: 39px;
            line-height: 39px;

            font-size: 13px;
          }

          .button {
            width: 50px;

            min-height: 38px;
            line-height: 38px;

            height: 40px;
            font-size: 16px;
          }
          .params {
            padding: 5px 0 0 0;
          }
        }
      }

      .item-icon-right .icon {
        font-size: 16px;
        right: 5px;
      }

      .bar-header {
        .title {
          font-size: 18px;
          top: -2px;
          height: 44px;
          line-height: 44px;
        }
        &.bar .title + .button:before {
          font-size: 28px;
        }
      }
    }
  }
</style>
